import React, {useEffect, useState} from 'react';
import { Modal, Button, Form, Row, Col, Card, Table, Badge, Dropdown, Pagination,  } from 'react-bootstrap';
import {useNavigate} from "react-router-dom";
import FormControl from "../../../shared/components/FormControl";
import {businessYearService} from "../../../services/businessYearService";
import eventEmitter from "../../../shared/eventEmitter";
import {EventEmitterTypes} from "../../../shared/eventEmitterEnum";
import notificationService from "../../../services/NotificationService";
import NotificationService from "../../../services/NotificationService";

interface PricePerSqFtModalProps {
    details?: SeasonDates;
    year: number;
    show: boolean;
    toggle: () => void;
}

interface SeasonDates {
    startDate: string;
    endDate: string;
    priceAdjustmentId: number;
    name: string;
    amount: number;
    percentage: number;
}


const PriceAdjustmentsModal: React.FC<PricePerSqFtModalProps> = ({details, year, show, toggle}) => {
    const [startDate, setStartDate] = useState<string>(null);
    const [endDate, setEndDate] = useState<string>(null);
    const [name, setName] = useState<string>('');
    const [unit, setUnit] = useState<string>('');
    const [PlusMinus, setPlusMinus] = useState<string>('');
    const [amount, setAmount] = useState<number>(null);

    const [showErrors, setShowErrors] = useState(false);

    function handleSave() {
        let signedAmount = amount;
        if(PlusMinus === 'minus')
            signedAmount = -1 * signedAmount
        let postData = {
            ...(details ? { priceAdjustmentId: details.priceAdjustmentId } : {}),
            name: name,
            startDate: startDate,
            endDate: endDate,
            ...(unit === 'Dollar' ? {amount: signedAmount, percentage: null} : {percentage: signedAmount, amount: null})
        }
        if(details)
            businessYearService.updatePriceAdjustments(postData, year).then(r => {
                eventEmitter.emit(EventEmitterTypes.REFRESH_LOADED_YEAR_ADJUSTMENTS);
                toggle();
            })
        else
            businessYearService.createPriceAdjustments(postData, year).then(r => {
                eventEmitter.emit(EventEmitterTypes.REFRESH_LOADED_YEAR_ADJUSTMENTS);
                toggle();
            })
    }
    useEffect(() => {
        if(details){
            setStartDate(details.startDate);
            setEndDate(details.endDate);
            setName(details.name);
            setAmount(details.amount)
            if(details.amount){
                if(details.amount < 0){
                    setPlusMinus('minus')
                } else
                    setPlusMinus('plus')
                setAmount(Math.abs(details.amount))
                setUnit('Dollar')
            }
            if(details.percentage){
                if(details.percentage < 0){
                    setPlusMinus('minus')
                } else
                    setPlusMinus('plus')
                setAmount(Math.abs(details.percentage))
                setUnit('Percent')
            }
            
        } else {
            setStartDate(null);
            setEndDate(null);
        }
        
    }, [details]);
    
    return (
        <Modal show={show} onHide={toggle}>
            <Modal.Header closeButton>
                <h5 className="modal-title" id="profileModalTitle">Price Adjustments</h5>
            </Modal.Header>
            <Modal.Body>
                <Form>
                    <div className="row gx-3">
                        <Form.Group controlId="Name" className="col-md-6 mb-3">
                            <FormControl
                                type="text"
                                label={"Name"}
                                value={name}
                                placeholder='Date Name'
                                showErrors={showErrors}
                                onChange={(e) => setName(e.target.value)}
                                required
                            />
                        </Form.Group>
                    </div>
                    <div className="row gx-3">
                        <Form.Group controlId="date" className="col-md-6 mb-3">
                            <FormControl
                                type="date"
                                label={"Start Date"}
                                showErrors={showErrors}
                                value={startDate}
                                onChange={(e) => setStartDate(e.target.value)}
                                placeholder="Select a date"
                                required
                            />
                        </Form.Group>
                        <Form.Group controlId="date" className="col-md-6 mb-3">
                            <FormControl
                                label={"End Date"}
                                type="date"
                                value={endDate}
                                showErrors={showErrors}
                                onChange={(e) => setEndDate(e.target.value)}
                                placeholder="Select a date"
                                required
                            />
                        </Form.Group>
                    </div>
                    <div className="row gx-3">
                        <Form.Group controlId="plusMinus" className="col-md-3 mb-3">
                            <Form.Label>Plus/Minus<sup className="text-danger">*</sup></Form.Label>
                            <Form.Select
                                aria-label="PlusMinus"
                                value={PlusMinus}
                                onChange={(e) => setPlusMinus(e.target.value)}
                                required
                            >
                                <option value="">Select</option>
                                <option value="plus">+ Plus</option>
                                <option value="minus">- Minus</option>
                            </Form.Select>
                        </Form.Group>
                        <Form.Group controlId="Unit" className="col-md-6 mb-3">
                            <Form.Label>Unit<sup className="text-danger">*</sup></Form.Label>
                            <Form.Select
                                aria-label="Unit"
                                value={unit}
                                onChange={(e) => setUnit(e.target.value)}
                                required
                            >
                                <option value="">Select</option>
                                <option value="Dollar">$ Dollar</option>
                                <option value="Percent">% Percent</option>
                            </Form.Select>
                        </Form.Group>
                        <Form.Group controlId="Amount" className="col-md-3 mb-3">
                            <FormControl
                                type="number"
                                label={"Amount"}
                                value={amount}
                                showErrors={showErrors}
                                onChange={(e) => setAmount(parseFloat(e.target.value))}
                                required
                            />
                        </Form.Group>
                    </div>
                    
                </Form>
            </Modal.Body>
            <Modal.Footer>
                <Button className="btn btn-primary text-strong text-uppercase m-100" onClick={handleSave}>
                    Save
                </Button>
                <Button className="btn btn-cancel text-strong text-uppercase m-100" onClick={toggle}>
                    Cancel
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default PriceAdjustmentsModal;
